<template>
	<div class="content-wrapper">
		<pageheader title="Update User"></pageheader>
		<div class="content">
			<div v-if="isLoaded" class="row">
				<div class="col-md-12 ">
					<userupdate :element="elementData" @user:update="onUpdate" @user:canceled="onCanceled"/>
				</div>
			</div>
			<div v-else >
				<div style="height: 100px">
					<div class="loader loader-inline no-margin-top"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import pageheader from '@components/pages/elements/header'
import uiUsers from '@components/pages/users'

export default {
	name: 'UserEdit',
	props : {
        id: {
            type: [Number, String],
            default : null
        },
        element: {
            type: Object,
            default : null
        },
    },
    created () {
        if (this.id == null){
        	this.$store.dispatch('pnotify/alert', {
		        text: 'Invalid user link',
		        addclass: 'bg-danger border-danger'
		    }, {root:true});
            this.$router.push({ name : 'users-view' });
        }
        if (this.element == null){
        	this.$store.dispatch('users/getById', {
        		id : this.id
        	})
			.then((response) => {
				this.elementData = response.data
			})
			.catch( error => {
				this.$router.push({ name : 'users-view' });
            });
        }else{
        	this.elementData = this.element
        }

    },
	components : {
		pageheader,
		userupdate : uiUsers.edit

	},
	data() {
		return {
			elementData : null,
			isLoading : false
		}
	},
	watch: {
        isLoaded(){}
    },
	mounted(){
		this.initialize();
	},
	computed: {
		isLoaded(){
			return this.elementData != null
		}
	},
	methods: {
		initialize() {
			//this.loadConfig();
		},
        onUpdate: function(options){
        	this.$router.push({name : 'users-view-page', params: {page: options ? options.page : 1 }});
        },
        onCanceled: function(options){
        	this.$router.push({name : 'users-view-page', params: {page: options ? options.page : 1 }});
        }
	}
}
</script>